import { DrugsApi } from '@/api/domains/drugs.api';
import { useMutation } from '@tanstack/react-query';

export const useDeleteControlFetchDrugs = () =>
  useMutation({
    mutationFn: DrugsApi.deleteControlFetchDrugs,
  });
